const USER_DATA = "user/data";
const SET_USER_DATA = "SET_USER_DATA";
const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN";
const SET_JOINT_ADDENDUM_STATE = "SET_JOINT_ADDENDUM_STATE";
const GENERAL_DETAILS = "GENERAL_DETAILS";
const COVID_AND_NRI = "COVID_AND_NRI";
const TOAST_ERROR = "TOAST_ERROR";
const SET_PROPOSER_DETAILS = "SET_PROPOSER_DETAILS";
const SET_LEAD_ID = "SET_LEAD_ID";
const SET_MEDICAL_AND_LIFESTYLE = "SET_MEDICAL_AND_LIFESTYLE";
const SAVE_MEDICAL_AND_LIFESTYLE = "SAVE_MEDICAL_AND_LIFESTYLE";
const SAVE_GENERAL_DETAILS = "SAVE_GENERAL_DETAILS";
const SAVE_COVID_AND_NRI = "SAVE_COVID_AND_NRI";
const STEP_DETAILS = "STEP_DETAILS";
const SET_LEAD_DETAILS = "SET_LEAD_DETAILS";
const SAVE_PROPOSER_POST_DATA = "SAVE_PROPOSER_POST_DATA";
const OTP_VERIFICATION_DETAILS = "OTP_VERIFICATION_DETAILS";
const SET_POST_MEF_LOADING = "SET_POST_MEF_LOADING";
const VERIFY_OTP_LEAD_ID = "VERIFY_OTP_LEAD_ID";
const LOAN_STATUS = "LOAN_STATUS";
const MEF_UPLOAD_MODAL = "MEF_UPLOAD_MODAL";
const PROPOSAL_STATUS = "PROPOSAL_STATUS";
const IS_MASTER_LOADING = "IS_MASTER_LOADING";
const SIGNATURE_MODAL = "SIGNATURE_MODAL";
const IS_RECALCULATE_DONE = "IS_RECALCULATE_DONE";
const SET_RECALCULATE_ERROR = "SET_RECALCULATE_ERROR";
const SET_PROPORTIONATE_LEAD = "SET_PROPORTIONATE_LEAD";
const SET_PROPORTIONATE_PARENT_LEAD = "SET_PROPORTIONATE_PARENT_LEAD";
const SET_PRODUCT_ID = "SET_PRODUCT_ID";
const SAVE_NEW_LEAD_DETAILS = "SAVE_NEW_LEAD_DETAILS";
const SET_STAFF_MEMBER = "SET_STAFF_MEMBER";
const SAVE_PARTNER_DATA = "SAVE_PARTNER_DATA";
const SET_ASSIGNMENT_STEPPER_FLAG = "SET_ASSIGNMENT_STEPPER_FLAG";

export {
  USER_DATA,
  GENERAL_DETAILS,
  COVID_AND_NRI,
  SET_USER_DATA,
  SET_IS_LOGGED_IN,
  SET_JOINT_ADDENDUM_STATE,
  TOAST_ERROR,
  SET_PROPOSER_DETAILS,
  SET_LEAD_ID,
  SET_MEDICAL_AND_LIFESTYLE,
  SAVE_MEDICAL_AND_LIFESTYLE,
  SAVE_GENERAL_DETAILS,
  SAVE_COVID_AND_NRI,
  STEP_DETAILS,
  SET_LEAD_DETAILS,
  SAVE_PROPOSER_POST_DATA,
  OTP_VERIFICATION_DETAILS,
  SET_POST_MEF_LOADING,
  VERIFY_OTP_LEAD_ID,
  LOAN_STATUS,
  MEF_UPLOAD_MODAL,
  PROPOSAL_STATUS,
  IS_MASTER_LOADING,
  SIGNATURE_MODAL,
  IS_RECALCULATE_DONE,
  SET_RECALCULATE_ERROR,
  SET_PROPORTIONATE_LEAD,
  SET_PROPORTIONATE_PARENT_LEAD,
  SET_PRODUCT_ID,
  SAVE_NEW_LEAD_DETAILS,
  SET_STAFF_MEMBER,
  SAVE_PARTNER_DATA,
  SET_ASSIGNMENT_STEPPER_FLAG
};
